<template>
  <div class="modal-container">
    <div class="sel-modal-header clearfix">
      <vxe-radio-group v-model="selectTab">
        <ul class="tab-list">
          <li>
            <vxe-radio name="xtabs" label="tab1">新订单2.0</vxe-radio>
          </li>
        </ul>
      </vxe-radio-group>
      <div class="search-box" style="display: flex;align-items: center">
        <vxe-input
            v-model="searchOrdersSaleMan"
            type="search"
            placeholder="输入业务员"
            @search-click="search"
            @keyup.enter.native="search"
            style="width: 150px; margin-left: 10px"
        ></vxe-input>
        <Select
            v-model="searchOrdersBuyer"
            filterable
            :clearable="true"
            :remote-method="
            file =>
              remoteMethod(
                file,
                'buyerNameOptions',
                'twoOrders',
                'searchCondition',
                3
              )
          "
            :default-label="[]"
            :loading="searchLoading"
            :max-tag-count="1"
            :max-tag-placeholder="maxTagPlaceholder"
            @on-set-default-options="
            file => setDefaultOptions(file, 'buyerNameOptions')
          "
            placeholder="输入托运人名称"
            @search-click="search"
            @keyup.enter.native="search"
            style="width: 150px; margin-left: 10px"
        >
          <Option
              v-for="option in buyerNameOptions"
              :value="option.id"
              :key="option.name"
          >{{ option.name }}
          </Option>
        </Select>
        <Select
            v-model="searchOrdersCompName"
            filterable
            :clearable="true"
            :remote-method="
            file =>
              remoteMethod(
                file,
                'PlatIdListOption',
                'twoOrders',
                'searchCondition',
                1
              )
          "
            :default-label="[]"
            :loading="searchLoading"
            :max-tag-count="1"
            :max-tag-placeholder="maxTagPlaceholder"
            @on-set-default-options="
            file => setDefaultOptions(file, 'PlatIdListOption')
          "
            placeholder="输入平台企业"
            @search-click="search"
            @keyup.enter.native="search"
            style="width: 150px; margin-left: 10px"
        >
          <Option
              v-for="option in PlatIdListOption"
              :value="option.id"
              :key="option.name"
          >{{ option.name }}
          </Option>
        </Select>
        <vxe-input
            v-model="searchData.ordersNum"
            type="search"
            placeholder="订单编号"
            @keyup.enter.native="search"
            @search-click="search"
            class="choose-search-input"
            style="width: 150px; margin-left: 10px"
        ></vxe-input>
        <vxe-input
            style="width: 150px; margin-left: 10px"
            v-model="searchData.ordersTitle"
            type="search"
            placeholder="订单标题"
            @keyup.enter.native="search"
            @search-click="search"
            class="choose-search-input"
        ></vxe-input>
        <vxe-input
            style="width: 150px; margin-left: 10px"
            v-model="searchData.carShipNum"
            type="search"
            placeholder="车船号"
            @keyup.enter.native="search"
            @search-click="search"
            class="choose-search-input"
        ></vxe-input>
      </div>
    </div>
    <!-- <div class="choose-search-box">
      <vxe-input v-model="filterName" type="search" placeholder="搜索"  @keyup.enter.native="search" @search-click="search" class="choose-search-input"></vxe-input>
    </div>-->
    <div class="choose-box clearfix">
      <!-- <vxe-toolbar>
        <template v-slot:buttons>
          <vxe-input v-model="filterName" type="search" placeholder="搜索"  @keyup.enter.native="search" @search-click="search" class="choose-search-box"></vxe-input>
        </template>
      </vxe-toolbar>-->
      <vxe-table
          class="table-style"
          highlight-hover-row
          highlight-current-row
          show-overflow
          :auto-resize="true"
          border="none"
          align="center"
          max-height="450"
          stripe
          :loading="loading"
          :data="orderListData"
          @current-change="currentChangeEvent"
      >
        <vxe-table-column field="ordersNum" title="订单编号" width="130">
        </vxe-table-column>
        <vxe-table-column
            field="ordersTitle"
            title="订单标题"
            width="150"
        ></vxe-table-column>
        <vxe-table-column field="ordersState" title="订单状态" width="100">
          <template slot-scope="{ row }">
            <span>{{ row.ordersState | ordersStateMap }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="buyerName"
            title="托运人"
            width="150"
            align="center"
        >
        </vxe-table-column>

        <vxe-table-column
            field="compName"
            title="平台企业"
            width="200"
        ></vxe-table-column>
        <vxe-table-column
            field="sellerName"
            title="承运人"
            width="150"
            align="center"
        >
        </vxe-table-column>

        <vxe-table-column
            field="goodsName"
            title="货名"
            width="105"
            align="center"
        >
        </vxe-table-column>
        <vxe-table-column
            field="carShipNum"
            title="车船号"
            width="75"
            align="center"
        >
        </vxe-table-column>
        <vxe-table-column
            field="saleMan"
            title="业务员"
            width="100"
        ></vxe-table-column>
        <vxe-table-column
            field="createUser"
            title="创建人"
            width="100"
        ></vxe-table-column>
        <vxe-table-column field="createTime" title="创建时间" width="120">
          <template slot-scope="{ row }">
            <span>{{ row.createTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page.currentPage"
          :page-size.sync="page.pageSize"
          :total="page.totalResult"
          @page-change="changePage"
      ></vxe-pager>
    </div>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import $C from "@/consts/index";
import Auth from "@/utils/auth.js";
import {isEmpty} from "@/utils/util";
import moment from "moment";

export default {
  name: "ChooseContract",
  data() {
    let userInfoValue = {};
    if (Auth.isLogin()) {
      userInfoValue = Auth.getAuth();
    }
    return {
      searchData: {},
      userInfoValue,
      loading: false,
      detailVisible: false,
      filterName: "",
      contractTitle: "",
      orderListData: [{}],
      buyerNameOptions: [],
      platformCompanyOptions: [],
      saleManOptions: [],
      sellerNameOptions: [],
      PlatIdListOption: [],
      searchOrdersBuyer: "",
      searchOrdersCompName: "",
      searchOrdersSaleMan: "",
      searchLoading: false,
      page: {
        currentPage: 1,
        pageSize: 8,
        totalResult: 100
      },
      type: null,
      selectTab: "tab1",
      paramsObj: null
    };
  },
  activated() {
    this.init();
    this.getSelData()
  },
  methods: {
    maxTagPlaceholder(num) {
      return "更多+ " + num;
    },
    init() {
      this.searchData = {};
      this.paramsObj = null;
      this.page = {
        currentPage: 1,
        pageSize: 8,
        totalResult: 100
      };
      this.queryOrderList();
    },
    getSelData() {
      this.getList("", "buyerNameOptions", "twoOrders", "searchCondition", 3);
      this.getList("", "sellerNameOptions", "twoOrders", "searchCondition", 4);
      this.getList(
          "",
          "platformCompanyOptions",
          "twoOrders",
          "searchCondition",
          1
      );
      this.getList("", "saleManOptions", "twoOrders", "searchCondition", 5);
    },
    async queryOrderList() {
      this.loading = true;
      let res = await $api.twoOrders.post("list", {
        page: this.page.currentPage,
        rows: this.page.pageSize
      });
      if (res.status === 1) {
        this.page.totalResult = res.data.total;
        this.orderListData = res.data.rows;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error"
        });
      }
      this.loading = false;
    },

    changePage({currentPage, pageSize}) {
      // 分页
      if (!this.paramsObj) {
        this.page.currentPage = currentPage;
        this.page.pageSize = pageSize;
        let changeObj = {
          page: this.page.currentPage,
          rows: this.page.pageSize
        };
        this.queryOrderListByObj(changeObj);
      } else {
        let obj = {
          page: currentPage,
          rows: pageSize
        };
        Object.assign(obj, this.paramsObj);
        this.queryOrderListByObj(obj);
      }
    },
    clickEvent3(rowIndex) {
      this.$refs[rowIndex].togglePanel();
    },
    currentChangeEvent({row}) {
      this.$emit("choose", row);
    },
    search() {
      this.loading = true;
      this.page.currentPage = 1;
      let obj = this.searchData;
      let paramsObj = {};
      this.currentPage = 1;
      Object.keys(obj).forEach(key => {
        if (obj[key] !== null && key !== "time") {
          paramsObj[key] = obj[key];
        }
      });
      if (this.searchOrdersBuyer) {
        paramsObj.buyerId = this.searchOrdersBuyer;
      }
      if (this.searchOrdersCompName) {
        paramsObj.platformCompanyId = this.searchOrdersCompName;
      }
      paramsObj.page = 1;
      paramsObj.rows = 10;
      this.paramsObj = paramsObj;
      this.queryOrderListByObj(obj);
    },

    async queryOrderListByObj(obj) {
      this.loading = true;
      let res = await $api.twoOrders.post("list", obj);

      if (res) {
        this.page.totalResult = res.data.total;
        this.orderListData = res.data.rows;
        this.loading = false;
      }

      // $api.order.queryOrdersBuyerListWithoutPermission
      //   .POST({
      //     data: obj,
      //   })
      //   .then((res) => {
      //     this.page.totalResult = res.data.total;
      //     this.orderListData = res.data.rows;
      //     this.loading = false;
      //   });
    },
    cancel() {
    },
    remoteMethod(query, options, url, path, columnType) {
      if (query !== "") {
        this.searchLoading = true;
        this.getList(query, options, url, path, columnType);
      } else {
        this[options] = [];
      }
    },
    async getList(query, options, url, path, columnType) {
      let params = {
        cate: columnType
      };

      if (!isEmpty(query)) {
        params.keyword = query;
      }
      if (isEmpty(this[options])) {
        this.searchLoading = true;
      }
      let res = await $api[url].post(path, params);
      this.searchLoading = false;
      if (res.status === 1) {
        this[options] = res.data;
      }
    },
    setDefaultOptions(options, option) {
      this[option] = options;
    },
    close() {
      this.$refs.xTable.clearCurrentRow();
    }
  }
};
</script>

<style scoped>
.modal-container {
  position: relative;
  height: 100%;
}

.btn-down {
  border: none;
}

.btn-down:focus {
  outline: none;
  border-color: transparent;
  box-shadow: none;
  background: transparent;
}

.btn-down.ivu-btn {
  background: transparent;
}

.btn-down.ivu-btn:hover {
  background: transparent;
}
</style>